import { Injectable } from '@angular/core';
import moment from 'moment';
import { getSpanishPlateType } from '../validators/spanish-plate.validator';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  constructor() {}

  esMatriculaEspanola(matricula: string) {
    return getSpanishPlateType(matricula);
  }

  toIsoAtUtcMidnightKeepDay(d: any): string | null {
    if (!d) return null;
    return moment(d)
      .startOf('day') // 00:00 hora local del dia seleccionat
      .utcOffset(0, true) // canvia a UTC sense moure l'hora (manté 00:00)
      .toISOString(); // -> 2025-12-22T00:00:00.000Z
  }
}
